import * as React from 'react';
const IconEdit = ({ color = '#000' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 25 25" fill="none">
    <path
      d="M4.13339 14.3372L16.9706 1.5L22.6274 7.15685L9.79024 19.994L2.82845 21.299L4.13339 14.3372Z"
      stroke={color}
      strokeWidth={3}
      strokeLinejoin="round"
    />
  </svg>
);
export default IconEdit;
